import { Layout } from "antd";
import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { useResizeObserver } from "../../hooks/useResizeObserver";
import { computeBookingPriceDollars } from "../../lib/price";
import { Cart } from "./Cart";
import { FEE } from "./savings";
import { rollingTotalTint } from "./rolling-total";
import { Logo } from "./Logo";
import { OrderSummary } from "./OrderSummary";

export const Sidebar = (props: any) => {
  const dispatch = useDispatch();
  const {
    types,
    bedrooms,
    bathrooms,
    codeDiscount,
    totalPrice,
    isFlexible,
    discount,
    occurance,
    addOns,
  } = useSelector(
    // @ts-ignore
    (state) => state.bookingReducer
  );

  // Was a byte-identical copy of hooks/usePrice.ts, which itself disagreed with
  // the reducer on where to round. One implementation now, shared with the server.
  const getSubtotal = useCallback(
    (): number =>
      computeBookingPriceDollars({
        bedrooms,
        bathrooms,
        types,
        occurance,
        isFlexible,
        codeDiscount,
        addOns,
      }).subTotal,
    [bathrooms, bedrooms, types, isFlexible, occurance, codeDiscount, addOns]
  );

  let width = useResizeObserver();

  return (
    <Layout className="sidebar">
      {width > 768 ? (
        <OrderSummary types={types} bedrooms={bedrooms} bathrooms={bathrooms} />
      ) : null}
      <Cart
        subTotal={getSubtotal()}
        dispatch={dispatch}
        totalPrice={totalPrice}
        discount={discount}
      />
    </Layout>
  );
};

const SummaryContainer = styled.div`
  padding: 25px;
  background-color: #eefcff;
  h1 {
    margin-top: 1vh;
    font-weight: 600;
    color: #373744;
  }
  .blue {
    font-weight: 600;
    color: #323593;
  }
  color: #000;
`;

const CartContainer = styled.div`
  width: 100%;
  bottom: 0;
  background-color: #dff9ff;
  margin-top: 5vh;
  padding: 25px;
  color: #000;
  .blue {
    font-weight: 600;
    color: #323593;
  }
  /* A charge announces itself in amber and a saving in green, and the two are
     never swapped — see savings.ts. Fee rows are plain <p> here rather than
     their own component, so the keyframes live with the container they sit in. */
  @keyframes cart-wash-fee {
    from {
      background: ${FEE.tint};
      box-shadow: inset 0 0 0 1px ${FEE.edge};
    }
    to {
      background: transparent;
      box-shadow: inset 0 0 0 1px transparent;
    }
  }
  p.washing-fee {
    padding: 2px 6px;
    margin: 0 -6px;
    border-radius: 6px;
    animation: cart-wash-fee 520ms ease-out both;
  }

  /* The total tints as it rolls — green when it drops, amber when it climbs.
     With the pill, the only two things that move for every change there is.
     Shared with the sticky bar, which shows the same number. */
  ${rollingTotalTint}

  @media (prefers-reduced-motion: reduce) {
    p.washing-fee {
      animation: none;
    }
  }

  /* The caveat under a pre-date "Total from:" — secondary to the number it
     qualifies, but not so faint that it reads as decoration. */
  .cart-price-note {
    margin: 4px 0 0;
    font-size: 0.75rem;
    line-height: 1.35;
    color: rgba(50, 53, 147, 0.72);
  }
  @media screen and (max-width: 991px) {
    padding: 25px;
  }
`;

export { Logo, CartContainer, SummaryContainer };
export { CreditLoginModal } from "./CreditLoginModal";
